<p-splitter [panelSizes]="[25, 75]" [style]="{ height: '100%' }" styleClass="mb-2">
  <ng-template pTemplate>
    <div class="col" [style]="{ overflow: 'auto' }">
      <div [style]="{ width: '100%'}">
        <input pInputText placeholder="Search" type="text" [(ngModel)]="menuSearch" (keyup)="onMenuSearchChanged()" [style]="{ width: 'calc(100% - 2px)'}"/>

        <div>
          <p-progressSpinner *ngIf="!items" ariaLabel="loading" />
          <p-tree #mt [lazy]="true" *ngIf="items" [value]="items" loadingMode="icon"
            (onNodeExpand)="onNodeExpand($event)" scrollHeight="flex" selectionMode="single"
            (onNodeSelect)="navItemSelected($event)" (onNodeUnselect)="navItemSelected($event)"
            [style]="{ borderStyle: 'none'}">
            <ng-template let-node pTemplate="menu">
              <div class="flex align-items-center">
                <!-- <i class="pi pi-fw" [ngClass]="node.data.icon"></i> -->
                <span class="ml-2">{{ node.data.title }}</span>
              </div>
            </ng-template>
          </p-tree>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate>
    <div class="flex col">
      <p-treeTable #pt *ngIf="selectedProgram" [value]="pgmItems" [loading]="!pgmItems || !pgmItems.length"
        scrollHeight="flex" [columns]="cols" sortMode="multiple" filterMode="lenient" scrollable="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="!col.hidden" [ttSortableColumn]="col.field" [ngStyle]="{'min-width': col.width + 'px'}"
                [title]="col.title||''">
                {{col.label}}
                <p-treeTableSortIcon [field]="col.field" />
              </th>
            </ng-container>
          </tr>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="!col.hidden">
                <p-multiSelect *ngIf="col.options && col.matchMode !== 'equals'" [(ngModel)]="col.filterValue"
                  [options]="col.options" (onChange)="applyFilter(pt, $event, col.field, col.matchMode)"
                  [filter]="false" [showHeader]="false" placeholder="All" appendTo="body" optionLabel="label"
                  optionValue="value" scrollHeight="400px">
                </p-multiSelect>
                <input pInputText placeholder="All"
                  [style]="{ width: '100%', textTransform: !col.upperCase ? '' : 'uppercase'}"
                  [attr.maxlength]="col.maxLength" *ngIf="!col.options" type="text"
                  (input)="applyFilter(pt, $event, col.field, 'contains')" />
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
          <tr [ttRow]="rowNode">
            <td *ngFor="let col of columns; let i = index">
              <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0" />
              {{ col.getText ? getText(rowData, col) : rowData[col.field] }}
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
  </ng-template>

</p-splitter>